import React, {FC, useEffect, useState, useMemo, useRef} from 'react';
import axios from "axios";
import {useGoogleFonts} from "../../hooks/useGoogleFonts";
import {useAction} from "../../../../store/hooks/useAction";
import {useTypedSelector} from "../../../../store/hooks/useTypedSelector";
import {useLocation, useNavigate, useParams} from "react-router-dom";
import QuickbetXSwipeableMarkets from "../component/QuickbetX/QuickbetXSwipeableMarkets";
import {TokenDataInterface} from "../../Quicktip/helpers/quicktipHelpers";
import {useTranslation} from "react-i18next";
import i18n from "i18next";
import JackpotModalError from "../../Jackpot/heplers/JackpotModalError";
import JackpotError from "../../Jackpot/heplers/JackpotError";
import SwipeTour from "./SwipeTour";
import JackpotLoader from "../../Jackpot/heplers/JackpotLoader";
import QuickbetXSettingsModal from "../../QuickbetX/helpers/QuickbetSettingsModal";
type TicketSettings = {
    odds: {odds: number | null, direction: string } | null;
    markets: string[];
    events: { id: string; market: string }[];
};

let token = localStorage.getItem("token");

const SwipeQuickbetXTicket: FC = () => {
    const isInitialMount = useRef(true);
    let operatorName = '';
    const { id } = useParams();
    const { t } = useTranslation();
    const navigate = useNavigate();
    const location = useLocation();
    const params = new URLSearchParams(location.search);
    const atag = params.get('atag');
    const rtag = params.get('rtag');
    const lang = params.get('lang');
    let currentToken = params.get('token');
    let isAuth = (token !== null && token.length > 0) || (currentToken !== null && currentToken.length > 0);
    const [paystackURL, setPaystackUrl] = useState('');
    const [paystackTrackURL, setPaystackTrackUrl] = useState('');
    const [hidePaystack, setHidePaystack] = useState(false);
    const [showTour, setShowTour] = useState(false);
    const [stake, setStake] = useState<number>(0);
    const [price, setPrice] = useState<number>(0);
    const [isLoadingMore, setIsLoadingMore] = useState(false);
    const [displayedEvents, setDisplayedEvents] = useState<any[]>([]);
    const [isLoadingSpinner, setIsLoadingSpinner] = useState(false);
    const [ticketSettings, setTicketSettings] = useState<TicketSettings>({
        odds: null,
        markets: [],
        events: []
    });

    const [ticketSummary, setTicketSummary] = useState({
        price: 0,
        total_odds: 0,
        stake: 0,
        ext: 0,
        ext_amount: 0,
        ext_type: "",
        wht: 0,
        wht_amount: 0,
        gross_payout: 0,
        net_payout: 0
    });
    const [loadedFonts, setLoadedFonts] = useState<string[] | null>(null);
    useGoogleFonts(loadedFonts || []);
    const [selectedMarkets, setSelectedMarkets] = useState<any[]>([]);
    const [showSettingsModal, setShowSettingsModal] = useState(false);
    const [hasMoreEvents, setHasMoreEvents] = useState(true);
    const [showPaymentBlock, setShowPaymentBlock] = useState(false);
    const [currentEventIndex, setCurrentEventIndex] = useState<number>(0);
    const [tokenData, setTokenData] = useState<TokenDataInterface>({
        type: '',
        tokenValue: '',
    })
    const [marketsCount, setMarketsCount] = useState({
        totalMarket: 0,
        markedMarket: 0,
        minTicketEvents: 0,
        minTicketOdds: 0,
        showHideMarketsButton: false
    });

    const [ticketAction, setTicketAction] = useState<{
        code: string;
        atag: string;
        rtag: string;
        stake: number;
        price: number;
        msisdn: string;
        player_id?: string;
        events: any[];
    }>({
        code: "",
        atag: "",
        rtag: "",
        stake: 0,
        price: 0,
        msisdn: "",
        events: []
    });
    const [loadingOPT, setLoading] = useState(false);
    const [showModal, setShowModal] = useState(false);
    const [errorOPT, setError] = useState<{ code: number; message: string } | null>(null);
    const [optSecureCode, setOptSecureCode] = useState('');
    const [briteURL, setBriteUrl] = useState('');
    const [trackURL, setTrackUrl] = useState('');
    const { getQuickbetXData, initOperator, initPlayer,getQuickbetXFilterData, calculationTicketsValue } = useAction();
    const { operatorData, operatorErrorDara } = useTypedSelector((state) => state.operatorReducer);
    const { calculationData } = useTypedSelector((state) => state.calculationReducer);
    const { quickbetsXFilterData, quickbetsXFilterDataLoading } = useTypedSelector((state) => state.quickbetXFilterReducer);
    const { quickbetXData, quickbetXerror, quickbetXloading } = useTypedSelector((state) => state.quickbetXReducer);
    const { playerData } = useTypedSelector((state) => state.playerReducer);
    operatorName = Object.keys(operatorData).length > 0 ? operatorData.operator : operatorName;

    const calculateMarkets = () => {
        const totalMarketCalc = quickbetXData.events.length;
        const markedMarketCalc = selectedMarkets.length;
        const stakesMinLimit = quickbetXData.min_ticket_events_count;
        const oddsMinLimit = quickbetXData.min_ticket_odds;

        const isMarketsEnough = markedMarketCalc >= stakesMinLimit;
        const isOddsEnough = calculationData.total_odds >= oddsMinLimit;

        setMarketsCount(prevState => ({
            ...prevState,
            totalMarket: totalMarketCalc,
            markedMarket: markedMarketCalc,
            minTicketEvents: stakesMinLimit,
            minTicketOdds: oddsMinLimit,
            showHideMarketsButton: isMarketsEnough && isOddsEnough
        }));
    };

    const setOddsFilterValue = (odds: number | null) => {
        if (odds === null) {
            setTicketSettings((prev: any) => ({
                ...prev,
                odds: null
            }));
        } else {
            setTicketSettings((prev: any) => ({
                ...prev,
                odds: { ...prev.odds, odds: odds, direction: 'lt' }
            }));
        }
        setIsLoadingSpinner(true);
    };

    const toggleMarketFilter = (market: string) => {
        if (market === 'ALL') {
            setTicketSettings((prev: any) => ({ ...prev, markets: [] }));
        } else {
            setTicketSettings((prev: any) => {
                const exists = prev.markets.includes(market);
                return {
                    ...prev,
                    markets: exists ? prev.markets.filter((m: string) => m !== market) : [...prev.markets, market]
                };
            });
        }
    };
    const getOddsArray = (markets: any[]) => {
        return markets.map(market => market.odds);
    };

    const calculateSummary = async () => {
        if (selectedMarkets.length > 0) {
            const totalOddsArr = getOddsArray(selectedMarkets);
            await calculationTicketsValue(price, totalOddsArr);
        }
    };
    const hundleToken = (tokenVal: string) => {
        const phoneRegex = /^\+?\d+$/;
        const codeRegex = /^[a-zA-Z0-9]+$/;
        if (phoneRegex.test(decodeURIComponent(tokenVal))) {
            setTokenData((prevState => ({
                ...prevState,
                type: 'phone',
                tokenValue: decodeURIComponent(tokenVal)
            })))
        } else if (codeRegex.test(tokenVal)) {
            setTokenData((prevState => ({
                ...prevState,
                type: 'code',
                tokenValue: tokenVal
            })))
        } else {
            setTokenData((prevState => ({
                ...prevState,
                type: '',
                tokenValue: ''
            })))
        }
    }

    useEffect(() => {
        setTicketSummary({
            price: calculationData.price,
            total_odds: calculationData.total_odds,
            stake: calculationData.stake,
            ext: calculationData.ext,
            ext_amount: calculationData.ext_amount,
            ext_type: calculationData.ext_type,
            wht: calculationData.wht,
            wht_amount: calculationData.wht_amount,
            gross_payout: calculationData.gross_payout,
            net_payout: calculationData.net_payout
        });
    }, [calculationData]);

    const setBet = (obj: any) => {
        const existingBetIndex = selectedMarkets.findIndex(market => market.id === obj.id);

        if (existingBetIndex !== -1) {
            const updatedMarkets = selectedMarkets.map((market, index) =>
                index === existingBetIndex ? { ...market, bet: obj.bet } : market
            );
            setSelectedMarkets(updatedMarkets);

        } else {
            setSelectedMarkets((prevObjects) => [...prevObjects, obj]);
        }

        setTicketSettings((prev: any) => {
            const existingEventIndex = prev.events.findIndex((e: any) => e.id === obj.id);
            let updatedEvents;
            if (existingEventIndex !== -1) {
                updatedEvents = prev.events.map((e: any, i: number) =>
                    i === existingEventIndex ? { id: obj.id, market: obj.market.market_code } : e
                );
            } else {
                updatedEvents = [...prev.events, { id: obj.id, market: obj.market.market_code }];
            }
            return { ...prev, events: updatedEvents };
        });

        setCurrentEventIndex(prevIndex =>
            Math.min(prevIndex + 1, displayedEvents.length - 1)
        );
    };

    const prepareData = (arr: any[]) => {
        const transformedArray = arr.map(item=> ({
            event_id: item.event_id,
            bet_id: item.bet_id,
            odds: item.odds,
        }));
        return transformedArray
    }
    const handleChangeNumber = (number: string) => {
        setTicketAction(prevState => ({
            ...prevState,
            msisdn: number,
        }))
    }

    const initBrite = async () => {
        let responseUrl;
        let requestData;
        if (selectedMarkets.length < 0) {
            setError({ code: 1, message:  t('notifications.missedBet') });
            setShowModal(prevState => !prevState)
            return;
        }
        if (ticketAction.price > playerData.balance) {
            setError({ code: 1, message: `${t('notifications.notEnoughMoney1') } ${playerData.balance}. ${t('notifications.notEnoughMoney2') }: ${ticketAction.price}. ${t('notifications.notEnoughMoney3') }`});
            setShowModal(prevState => !prevState)
            return;
        }
        if (operatorData?.psp.some((item: string) => item === 'brite')) {
            responseUrl = '/api/quickbetxs/reserve'
            requestData = {
                ...ticketAction,
                player_id: 'brite',
            }
        } else {
            return
        }

        try {
            setLoading(true);
            const response = await axios.post(responseUrl, requestData);
            setBriteUrl(response.data.token);
            setTrackUrl(response.data.code);
        } catch (error: any) {

            setError(error.response.data);
            setShowModal(prevState => !prevState)
        } finally {
            setLoading(false);
        }
    };
    const clearBriteSession = () => {
        setBriteUrl('');
        setTrackUrl('');
    }
    const initPaystack = async () => {
        let responseUrl;
        let requestData;

        if (tokenData && tokenData.type === 'phone') {
            setTicketAction((prevState => ({
                ...prevState,
                msisdn: tokenData.tokenValue,
            })))
        }
        if (ticketAction.price === 0) {
            setError({ code: 1, message: t('notifications.missedPrice') });
            setShowModal(prevState => !prevState)
            return;
        }
        if (ticketAction.price > playerData.balance) {
            setError({ code: 1, message: `${t('notifications.notEnoughMoney1') } ${playerData.balance}. ${t('notifications.notEnoughMoney2') }: ${ticketAction.price}. ${t('notifications.notEnoughMoney3') }`});
            setShowModal(prevState => !prevState)
            return;
        }
        if (ticketAction.msisdn.length === 0) {
            setError({ code: 1, message: t('notifications.missedPhone') });
            setShowModal(prevState => !prevState)
            return;
        }

        if (operatorData?.psp.some((item: string) => item === 'paystack')) {
            responseUrl = '/api/quickbetxs/reserve'
            requestData = {
                ...ticketAction,
                psp: 'paystack',
            }
        } else {
            return
        }

        try {
            setLoading(true);
            const response = await axios.post(responseUrl, requestData);
            setPaystackUrl(response.data.token);
            setPaystackTrackUrl(response.data.code);
        } catch (error: any) {

            setError(error.response.data);
            setShowModal(prevState => !prevState)
        } finally {
            setLoading(false);
        }
    };
    const handleHidePaystackBlock = () => {
        setHidePaystack(prevState => !prevState);
    }
    const clearPaystackSession = () => {
        setPaystackUrl('');
        setPaystackTrackUrl('');
        setTicketAction(prevState => ({
            ...prevState,
            msisdn: ''
        }))
    }
    const stakeBet = async () => {
        let responseUrl;
        if (selectedMarkets.length < 0) {
            setError({ code: 1, message:  t('notifications.missedBet') });
            setShowModal(prevState => !prevState)
            return;
        }
        if (ticketAction.price > playerData.balance) {
            setError({ code: 1, message: `${t('notifications.notEnoughMoney1') } ${playerData.balance}. ${t('notifications.notEnoughMoney2') }: ${ticketAction.price}. ${t('notifications.notEnoughMoney3') }`});
            setShowModal(prevState => !prevState)
            return;
        }
        if (!isAuth) {
            responseUrl = '/api/quickbetxs/reserve'
            if (ticketAction.msisdn.length === 0) {
                setError({ code: 1, message: t('notifications.missedPhone') });
                setShowModal(prevState => !prevState)
                return;
            }
        } else {
            if (tokenData.type === 'phone') {
                responseUrl = '/api/quickbetxs/reserve'
            } else {
                responseUrl = '/api/quickbetxs/create';
            }
        }

        try {
            setLoading(true);
            const response = await axios.post(responseUrl, ticketAction);
            setOptSecureCode(response.data.code);
        } catch (error: any) {

            setError(error.response.data);
            setShowModal(prevState => !prevState)
        } finally {
            setLoading(false);
        }
    };
    const makeMarketVisible = (toggle: boolean) => {
        setShowPaymentBlock(toggle);
    }
    useEffect(()=>{
        if (id) {
            getQuickbetXData(id)
            initOperator();
        }
        if (token){
            hundleToken(token);
        } else if (currentToken) {
            hundleToken(currentToken);
        }
        if (lang) {
            i18n.changeLanguage(lang);
        }
        if (atag && atag?.length > 0) {
            setTicketAction(prevState => ({
                ...prevState,
                atag: atag,
            }))
        }
        if (rtag && rtag?.length > 0) {
            setTicketAction(prevState => ({
                ...prevState,
                rtag: rtag,
            }))
        }
    }, [id])
    useEffect(() => {
        if (Object.keys(quickbetXData).length > 0 && Object.keys(operatorData).length > 0) {
            calculateSummary();
            const eventsData = prepareData(selectedMarkets);
            if (isAuth) {
                setTicketAction(prevState => ({
                    ...prevState,
                    psp: operatorData.psp[0],
                    events: eventsData,
                    code: quickbetXData.code,
                    stake: stake,
                    price: price,
                    player_id: playerData.id,
                }));
            } else {
                setTicketAction(prevState => ({
                    ...prevState,
                    psp: operatorData.psp[0],
                    events: eventsData,
                    price: price,
                    code: quickbetXData.code,
                    stake: stake
                }));
            }

            calculateMarkets();
        }
    }, [selectedMarkets, stake, quickbetXData]);

    useEffect(() => {
        if (tokenData.type === 'code') {
            initPlayer(`${tokenData.tokenValue}`)
        } else if (tokenData.type === 'phone') {
            setTicketAction((prevState => ({
                ...prevState,
                msisdn: tokenData.tokenValue,
                otp: "confirmed"
            })))
        }
    }, [tokenData]);

    useEffect(()=>{
        if (optSecureCode && !isAuth) {
            if (operatorName === 'mshikebet-ke') {
                navigate(`/quickbetx/tracking/${optSecureCode}`, {state: {style: quickbetXData.template, betcardСode: optSecureCode,betcardInfo: {ticketId: id, phone: ticketAction.msisdn}, operator: operatorName}});
            } else {
                navigate('/quickbetx/otp', {state: {style: quickbetXData.template, betcardСode: optSecureCode,betcardInfo: {ticketId: id, phone: ticketAction.msisdn}, operator: operatorName}});
            }
        } else if (optSecureCode && isAuth) {
            navigate(`/quickbetx/tracking/${optSecureCode}`, {state: {style: quickbetXData.template, betcardСode: optSecureCode,betcardInfo: {ticketId: id, phone: ticketAction.msisdn}, operator: operatorName}});
        }
    }, [optSecureCode])
    useEffect(()=>{
        if (trackURL.length > 0 && !briteURL) {
            navigate(`/quickbetx/tracking/${trackURL}`, {state: {style: quickbetXData.template, betcardСode: trackURL, operator: operatorName}});
        }
    }, [trackURL])
    const handleTourComplete = () => {
        setShowTour(false);
    };
    let triggerRedirectToTrack = () => {
        if (trackURL.length > 0){
            window.location.href = `/track/${trackURL}?ticketID=${id}`;
        }
        if (paystackTrackURL.length > 0) {
            window.location.href = `/track/${paystackTrackURL}?ticketID=${id}`;
        }
    };
    useEffect(() => {
        const tourCompleted = localStorage.getItem("swipeTourCompleted");
        if (!tourCompleted) {
            setShowTour(true);
        }
    }, []);

    useEffect(() => {
        if (quickbetXData?.template?.fonts) {
            setLoadedFonts([
                quickbetXData.template.fonts.fontFamily,
                quickbetXData.template.fonts.titleFontFamily
            ]);
        }
        if (quickbetXData.events && quickbetXData.events.length > 0) {
            setDisplayedEvents(quickbetXData.events);
            setTicketSettings((prev: any) => {
                const formattedEvents = quickbetXData.events.map((event: any) => ({
                    id: event.id,
                }));

                return {
                    ...prev,
                    events: [...prev.events, ...formattedEvents],
                };
            });
        }
    }, [quickbetXData]);
    useEffect(() => {
        if (isInitialMount.current) {
            return;
        }
        if (!Array.isArray(quickbetsXFilterData)) {
            return;
        }

        if (quickbetsXFilterData.length === 0) {

            if (ticketSettings.markets.length > 0 || (ticketSettings.odds && ticketSettings.odds.odds)) {
                setError({
                    code: 1,
                    message: t('notifications.noResultsFoundShowDefault')
                });
                setShowModal(true);
                toggleMarketFilter('ALL');
                setOddsFilterValue(null);
                return;
            } else {
                setError({
                    code: 1,
                    message: t('notifications.noMoreAvailableEvents')
                });
                makeMarketVisible(true);
                setHasMoreEvents(false);
                return;
            }
        }

        setDisplayedEvents(prev => [...prev, ...quickbetsXFilterData]);
        setTicketSettings((prev: any) => {
            const formattedEvents = quickbetsXFilterData.map((event: any) => ({
                id: event.id,
            }));

            return {
                ...prev,
                events: [...prev.events, ...formattedEvents],
            };
        });
        setIsLoadingSpinner(false)
    }, [quickbetsXFilterData]);

    useEffect(() => {
        if (displayedEvents.length <= 0) return;

        const remaining = displayedEvents.length - currentEventIndex - 1;
        const threshold = 2;

        if (remaining <= threshold && !isLoadingMore && hasMoreEvents) {
            const loadMore = async () => {
                setIsLoadingMore(true);
                try {
                    await getQuickbetXFilterData(quickbetXData.code, ticketSettings);
                } catch (error) {
                    console.error("error loading data:", error);
                } finally {
                    setIsLoadingMore(false);
                }
            };
            loadMore();
        }
    }, [currentEventIndex, displayedEvents, isLoadingMore, hasMoreEvents]);

    useEffect(() => {
        if (isInitialMount.current) {
            isInitialMount.current = false;
            return;
        }
        let updatedSettings;

        if (selectedMarkets.length === 0) {
            const skippedMarkets = ticketSettings.events.filter((ev: any) => ev.market);
            if (skippedMarkets.length > 0) {
                updatedSettings = {
                    ...ticketSettings,
                    events: skippedMarkets,
                };
            } else {
                updatedSettings = {
                    ...ticketSettings,
                    events: [],
                };
            }
        } else {
            const selectedMarketIds = new Set(selectedMarkets.map(market => market.id));

            const filteredEvents = ticketSettings.events.filter(event =>
                selectedMarketIds.has(event.id) ||
                event.market
            );
            updatedSettings = {
                ...ticketSettings,
                events: filteredEvents,
            };
        }
        setDisplayedEvents([]);
        setCurrentEventIndex(0);
        getQuickbetXFilterData(quickbetXData.code, updatedSettings);

    }, [ticketSettings.markets, ticketSettings.odds]);
    const handeTest = (arr: any[]) => {
        setSelectedMarkets((currentMarkets) => {
            const newSelectedMarkets = [...currentMarkets];
            arr.forEach(bet => {
                const existingBetIndex = newSelectedMarkets.findIndex(market => market.event_id === bet.event_id);

                if (existingBetIndex !== -1) {

                    newSelectedMarkets[existingBetIndex] = bet;
                } else {

                    newSelectedMarkets.push(bet);
                }
            });


            return newSelectedMarkets;
        });
        setCurrentEventIndex(prevIndex =>
            Math.min(prevIndex + arr.length, displayedEvents.length - 1)
        );
    }
    const skipedBet = (obj: any) => {
        if (!obj) {
            return;
        }

        setTicketSettings((prev: any) => {
            const existingEventIndex = prev.events.findIndex((e: any) => e.id === obj.id);

            if (existingEventIndex !== -1) {
                const updatedEvents = prev.events.map((e: any, i: number) =>
                    i === existingEventIndex ? { ...e, market: obj.market.market_code } : e
                );
                return { ...prev, events: updatedEvents };
            }
        });
        setCurrentEventIndex(prevIndex => Math.min(prevIndex + 1, displayedEvents.length - 1));
    };

    return (
        <>
            {
                errorOPT
                    ?
                    <JackpotModalError show={showModal} hide={setShowModal} error={errorOPT} styles={quickbetXData.template} /> :
                    null
            }
            {loadingOPT || isLoadingSpinner ? <JackpotLoader styles={quickbetXData.template} operator={operatorName} /> : null}
            {operatorErrorDara && Object.keys(operatorErrorDara).length > 0 ? <JackpotError error={operatorErrorDara} /> : null}
            {quickbetXerror ? <JackpotError error={quickbetXerror} /> : null}
            {!quickbetXloading && showTour && Object.keys(quickbetXData).length > 0 ? <SwipeTour onComplete={handleTourComplete} styles={quickbetXData.template} skipSwipe={true} /> : null}
            {
                Object.keys(quickbetXData).length > 0 && Object.keys(operatorData).length > 0 && !loadingOPT ?
                    <>
                        <QuickbetXSwipeableMarkets
                            paystackToken={paystackURL}
                            initPaystack={initPaystack}
                            hidePaystack={hidePaystack}
                            setHidePaystack={handleHidePaystackBlock}
                            clearPaystackSession={clearPaystackSession}
                            highlightOdds={ticketSettings.odds ? ticketSettings.odds.odds : null}
                            selectedMarkets={selectedMarkets}
                            showPaymentBlock={showPaymentBlock}
                            skipEvent={skipedBet}
                            makeMarketVisible={makeMarketVisible}
                            eventToShow={displayedEvents}
                            id={id}
                            language={operatorData.language}
                            languages={operatorData.languages}
                            styles={quickbetXData.template}
                            markets={displayedEvents}
                            operator={operatorName}
                            handleChangeNumber={handleChangeNumber}
                            data={quickbetXData}
                            currency={operatorData.currency}
                            isAuth={isAuth}
                            handeTest={handeTest}
                            ticketSummary={ticketSummary}
                            stakeBet={stakeBet}
                            initBrite={initBrite}
                            sessionToken={briteURL}
                            clearBriteSession={clearBriteSession}
                            triggerRedirectToTrack={triggerRedirectToTrack}
                            psp={operatorData.psp}
                            setStake={setStake}
                            setPrice={setPrice}
                            setBet={setBet}
                            price={price}
                            atag={atag}
                            rtag={rtag}
                            marketsCount={marketsCount}
                            onSwipeEventIndex={setCurrentEventIndex}
                            setShowSettingsModal={setShowSettingsModal}
                        />
                    </>
                    : null
            }
            {showSettingsModal ?
                <QuickbetXSettingsModal
                    styles={quickbetXData.template}
                    show={showSettingsModal}
                    hide={setShowSettingsModal}
                    toggleMarketFilter={toggleMarketFilter}
                    setOddsFilterValue={setOddsFilterValue}
                    ticketSettings={ticketSettings}
                />
                : null}
        </>
    );
}

export default SwipeQuickbetXTicket;